module.exports = __webpack_public_path__ + "img/facebook-icon.d02613ab.svg";